import React, { useContext } from 'react';
import { Container, Row, Col, Button, Modal, Table } from 'react-bootstrap';
import { useRef } from 'react';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';

export const Invoice = () => {
    const { invoice, invoiceModal, setInvoiceModal } = useContext(AppContext);
    const invoiceRef = useRef(null);

    const defaultData = {
        "username": "admin88",
        "status": "active",
        "license_status": "active",
        "license_expiry_date": "2026-01-30",
        "contact_details": "9496560899",
        "center_name": "Akshaya E Center",
        "address": "Demo address",
        "phone_numbers": "9",
        "agent": "Self",
        "user_count": 25,
        "trail_account": false,
        "package_id": 2,
        "package_name": "Basic Plan",
        "package_description": "(1 Admin + 5 Staff Accounts)\r\n\r\nThe Basic Plan supports small teams by enabling one administrator to manage up to five staff users efficiently. This package allows smooth delegation of daily operations while maintaining centralized administrative control.",
        "staff_count": 25,
        "amount_payable": 3000,
        "discount": 3000,
        "total_amount": 6000,
        "bill_date": "2026-01-02",
        "expiry_date": "2026-01-30",
        "paid": true
    };

    const data = invoice || defaultData;

    return (
        <Modal show={invoiceModal} onHide={() => setInvoiceModal(false)} size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>Pre-View Invoice</Modal.Title>
            </Modal.Header>
            <Modal.Body ref={invoiceRef}>
                <Container className="p-4 br-3 bdr2 mb-3 bg-white" >
                    {/* Header Section */}
                    <div className="d-flex justify-content-between align-items-center mb-4 pb-3 bdrb2">
                        <div className="d-flex align-items-center gap-3">
                            <div className="text-white d-flex align-items-center justify-content-center br-2">
                                <img src="https://portal.sevanasahayi.com/assets/logosquire.png" alt="" style={{ width: '50px' }} />
                            </div>
                            <div>
                                <h4 className="m-0 tp1 fw-bold">Sevana Support</h4>
                                <div className="f12 ts2">Technology for better future</div>
                            </div>
                        </div>
                        <div className="text-end">
                            <h2 className="t-blue fw-bold m-0">INVOICE</h2>
                            <div className="f12 ts1">Date: {data.bill_date}</div>
                            {data.paid && <div className="sucess-tag d-inline-block mt-1">PAID</div>}
                        </div>
                    </div>

                    {/* Addresses Section */}
                    <Row className="mb-4">
                        <Col xs={6}>
                            <h6 className="tp2 fw-bold text-uppercase f12 mb-2">From</h6>
                            <div className="tp1 fw-bold">Sevana Support Team</div>
                            <div className="ts2 f14">Ernakulam</div>
                            <div className="ts2 f14">Kerala, India</div>
                            <div className="ts2 f14">Email: support@sevanasahayi.com</div>
                        </Col>
                        <Col xs={6} className="text-end">
                            <h6 className="tp2 fw-bold text-uppercase f12 mb-2">Bill To</h6>
                            <div className="tp1 fw-bold">{data.center_name}</div>
                            <div className="ts2 f14">{data.username}</div>
                            <div className="ts2 f14">{data.address}</div>
                            <div className="ts2 f14">Ph: {data.contact_details}</div>
                        </Col>
                    </Row>

                    {/* Invoice Items */}
                    <div className="table-responsive">
                        <div className="f14 ts1 px-3">Invoice : {data.invoice_number}</div>
                        <table className="table">
                            <thead className="bgs1">
                                <tr>
                                    <th className="bdr-none tp2 f14 py-2 ps-3">Item Description</th>
                                    <th className="bdr-none tp2 f14 py-2 text-center" style={{ width: '150px' }}>Rate</th>
                                    <th className="bdr-none tp2 f14 py-2 text-center" style={{ width: '150px' }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="bdr-none py-3 ps-3">
                                        <div className="tp1 fw-bold">{data.package_name}</div>
                                        <div className="ts2 f12 p-multi-line mt-1">{data.package_description}</div>
                                        <div className="ts2 f12 mt-1">Expiry Date: {data.expiry_date}</div>
                                        <div className="mt-2">
                                            <span className="badge bg-light text-dark bdr1 me-1">Admin: 1</span>
                                            <span className="badge bg-light text-dark bdr1">Staff: {data.staff_count}</span>
                                        </div>
                                    </td>
                                    <td className="bdr-none py-3 text-center ts1">₹{data.total_amount}</td>
                                    <td className="bdr-none py-3 text-center ts1 fw-bold">₹{data.total_amount}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Totals Section */}
                    <Row className="mb-4">
                        <Col xs={7}>
                            <div className="p-3 bgs2 br-2">
                                <h6 className="tp1 f14 fw-bold mb-2">Terms & Conditions</h6>
                                <p className="ts2 f12 m-0">
                                    This invoice is issued for the subscription services mentioned above.
                                    Subscription fees are payable in advance and are non-refundable.
                                    The subscription shall remain valid until the expiry date ( {data.expiry_date} ) mentioned in this invoice.
                                    Services may be suspended if payment is not received on or before the due date.
                                    All applicable taxes are included in the billed amount.
                                    Any discrepancies in this invoice must be reported within seven (7) days from the invoice date, failing which the invoice shall be deemed accepted.
                                    This invoice is subject to the jurisdiction of the company’s registered location.

                                </p>
                            </div>
                        </Col>
                        <Col xs={5} className="d-grid align-items-center" >
                            <div className="ps-4">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="ts2">Sub Total:</span>
                                    <span className="tp1 fw-bold">₹{data.total_amount}</span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="ts2">Discount:</span>
                                    <span className="text-danger">- ₹{data.discount}</span>
                                </div>
                                <div className="bdrb1 mb-2"></div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="tp1 fw-bold f16">Total:</span>
                                    <span className="t-blue fw-bold f20">₹{data.amount_payable}</span>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Footer */}
                    <div className="text-center mt-5 pt-3 bdr0-t" style={{ borderColor: '#f0f0f0' }}>
                        <div className="f12 ts3">Thank you for your business!</div>
                        <div className="f12 ts3 mt-1">If you have any questions about this invoice, please contact support.</div>
                    </div>
                </Container>
            </Modal.Body>
            <Modal.Footer className="bdr-none">
                <Button onClick={() => generatePDF(invoiceRef, { filename: `invoice_${data.bill_date}.pdf` })} className="btn btn-t1 br-2">
                    <i className="bi bi-file-pdf me-2"></i>Download PDF
                </Button>
                <ReactToPrint
                    trigger={() => <button className="btn btn-t1-r br-2 ms-2"><i className="bi bi-printer me-2"></i>Print Invoice</button>}
                    content={() => invoiceRef.current}
                />
            </Modal.Footer>
        </Modal>
    )
}